// TODO - Documentar
import { Text } from '@blueprintjs/core'
import { TechnicalAnalysis } from 'react-ts-tradingview-widgets'
import { MARKET_ASSETS, SELECTED_MARKET_ASSET, TV_CODE } from '../../GlobalConstants'
import { RefApplicationParameterHook } from '../hooks/ApplicationParametersHooks'

function CustomTechnicalAnalysisWidget({parameters}) {
    

    const marketAssetId = RefApplicationParameterHook(SELECTED_MARKET_ASSET)

    // All Available assets
    const marketAssets = RefApplicationParameterHook(MARKET_ASSETS)
    
    return (
        <>
           { marketAssetId in marketAssets 
            ?<TechnicalAnalysis symbol={marketAssets[marketAssetId][TV_CODE]} interval="1h" locale="es" {...parameters} colorTheme="dark"/>
            :<div>
            <Text>Activo no Encontrado</Text>
           </div>
        }
            </>
    )
}

export default CustomTechnicalAnalysisWidget
